import ReduxHelper from 'lib/ReduxHelper';

export const APP_ACTION_TYPES = {
  LOGIN: 'LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',

  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAIL: 'CHANGE_PASSWORD_FAIL',

  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAIL: 'RESET_PASSWORD_FAIL',

  INITIAL_DATA_FETCH: 'INITIAL_DATA_FETCH',
  INITIAL_DATA_FETCH_SUCCESS: 'INITIAL_DATA_FETCH_SUCCESS',
  INITIAL_DATA_FETCH_FAIL: 'INITIAL_DATA_FETCH_FAIL',
  LOGOUT: 'LOGOUT',
  SUGGESTIONS_FETCH: 'SUGGESTIONS_FETCH',
  SUGGESTIONS_FETCH_COMPLETE: 'SUGGESTIONS_FETCH_COMPLETE',
  SUGGESTIONS_CLEAR: 'SUGGESTIONS_CLEAR',
  TOGGLE_HEADER_DROPDOWN: 'TOGGLE_HEADER_DROPDOWN',
  TOGGLE_HEADER_MENU: 'TOGGLE_HEADER_MENU',
  SHOW_ALERT: 'SHOW_ALERT',
  HIDE_ALERT: 'HIDE_ALERT',
};

export const fetchInitialData = () =>
  ReduxHelper.createAction(APP_ACTION_TYPES.INITIAL_DATA_FETCH);

export const login = (username, password, application) =>
  ReduxHelper.createAction(APP_ACTION_TYPES.LOGIN, {
    username,
    password,
    application,
  });

export const changePassword = (oldPassword, newPassword) =>
  ReduxHelper.createAction(APP_ACTION_TYPES.CHANGE_PASSWORD, {
    oldPassword,
    newPassword,
  });

export const resetPassword = partyId =>
  ReduxHelper.createAction(APP_ACTION_TYPES.RESET_PASSWORD, partyId);

export const logout = () => ReduxHelper.createAction(APP_ACTION_TYPES.LOGOUT);

export const fetchSuggestions = searchTerm =>
  ReduxHelper.createAction(APP_ACTION_TYPES.SUGGESTIONS_FETCH, searchTerm);

export const clearSuggestions = () =>
  ReduxHelper.createAction(APP_ACTION_TYPES.SUGGESTIONS_CLEAR);

export const toggleHeaderDropdown = (dropdown, forceValue) =>
  ReduxHelper.createAction(APP_ACTION_TYPES.TOGGLE_HEADER_DROPDOWN, {
    dropdown,
    forceValue,
  });

export const toggleHeaderMenu = (menu, forceValue) =>
  ReduxHelper.createAction(APP_ACTION_TYPES.TOGGLE_HEADER_MENU, {
    menu,
    forceValue,
  });

export const showAlert = (text, type, duration) =>
  ReduxHelper.createAction(APP_ACTION_TYPES.SHOW_ALERT, {
    text,
    type,
    duration,
  });

export const hideAlert = () =>
  ReduxHelper.createAction(APP_ACTION_TYPES.HIDE_ALERT);
